import classnames from 'classnames'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'

import Heart from '../../../../quince-site-common/src/organisms/appLayout/molecules/header/icons/heart.inline.svg'
import { IconButton } from '../icon-button'
import Link from '../link'
import ProductInfoPrice from '../productInfoPrice/ProductInfoPrice'
import ProductTraditionalDiscountMessage from '../productTraditionalDiscountMessage'
import ReviewStars from '../reviews/reviewStars'

import styles from './productInfo.module.scss'

export interface ProductInfoProps {
  productInfoHeaderClassName?: string
  productInfoHeaderTextClassName?: string
  productTitle: string
  formattedSalePrice?: string
  hideSalePrice?: boolean
  formattedTraditionalPrice?: string
  isWishListed?: boolean
  className?: string
  currency?: string
  avgRating?: number
  reviewCount?: number
  onWishListToggle?: (e: React.MouseEvent<HTMLElement>) => void
  hideWishListIcon?: boolean
  hideReviewSummary?: boolean
  onReviewSummaryClick?: (e: React.MouseEvent<HTMLElement>) => void
  savingPercentage?: number
  brandName?: string
  brandLink?: string
  traditionalDiscountMessage?: string
  formattedFestivalOfferPrice?: string
  showFullPDP?: boolean
  hideProductDetail?: boolean
  hideReviewCount?: boolean
  hideReviewLabel?: boolean
  productInfoReviewClassName?: string
  inStockMsgClass?: string
  showDiscount?: boolean
  pricePerServing?: number
  traditionalPricePerServing?: number
  isVitamin?: boolean
}

const ProductInfo = ({
  productInfoHeaderClassName,
  productInfoHeaderTextClassName,
  productTitle,
  formattedSalePrice,
  hideSalePrice = false,
  formattedTraditionalPrice,
  currency = '$',
  isWishListed = false,
  className,
  avgRating,
  reviewCount,
  onWishListToggle,
  hideWishListIcon,
  hideReviewSummary,
  onReviewSummaryClick,
  savingPercentage,
  brandName,
  brandLink,
  traditionalDiscountMessage,
  formattedFestivalOfferPrice,
  hideReviewCount,
  hideReviewLabel,
  productInfoReviewClassName,
  showDiscount,
  pricePerServing,
  traditionalPricePerServing,
  isVitamin,
}: ProductInfoProps) => {
  const classes = classnames(styles.container, className)

  const innerStyle = {
    fill: isWishListed ? 'black' : 'white',
    width: '20px',
    height: '18px',
  }

  return (
    <div className={classes}>
      {brandName &&
        (brandLink ? (
          <Link href={brandLink} className={styles.container__brandName}>
            {brandName}
          </Link>
        ) : (
          <div className={styles.container__brandNameWithoutLink}>{brandName}</div>
        ))}
      <div className={classnames(styles.container__header, productInfoHeaderClassName)}>
        <h1 className={classnames(styles.container__header__text, productInfoHeaderTextClassName)}>{productTitle}</h1>
        {!hideWishListIcon && (
          <IconButton
            className={styles.container__header__icon}
            iconSvg={Heart}
            innerStyle={innerStyle}
            onClick={onWishListToggle}
            ariaLabel="Mark product as favourite"
            dataTestId={isWishListed ? TEST_LOCATORS.REMOVE_FROM_WISHLIST_BUTTON : TEST_LOCATORS.ADD_TO_WISHLIST_BUTTON}
          />
        )}
      </div>
      {!hideReviewSummary && !!avgRating && Number(reviewCount) > 0 ? (
        <div className={styles.container__ratingAndReviews} onClick={onReviewSummaryClick}>
          <ReviewStars
            totalStars={5}
            fillStars={avgRating}
            className={styles.container__ratingAndReviews__rating}
            classNameIcon={styles.reviewStarIcon}
          />
          {reviewCount && !hideReviewCount && (
            <p
              data-testid={TEST_LOCATORS.FIRST_FOLD_REVIEW_COUNT}
              className={classnames(styles.container__ratingAndReviews__reviews, productInfoReviewClassName)}
            >
              (
              <span>
                {reviewCount}
                {hideReviewLabel ? '' : ' REVIEWS'}
              </span>
              )
            </p>
          )}
        </div>
      ) : null}
      {!hideSalePrice && !!formattedSalePrice && (
        <ProductInfoPrice
          formattedSalePrice={formattedSalePrice}
          formattedTraditionalPrice={formattedTraditionalPrice}
          currency={currency}
          savingPercentage={savingPercentage}
          formattedFestivalOfferPrice={formattedFestivalOfferPrice}
          showDiscount={showDiscount}
          pricePerServing={pricePerServing}
          traditionalPricePerServing={traditionalPricePerServing}
          isVitamin={isVitamin}
        />
      )}

      <ProductTraditionalDiscountMessage
        formattedTraditionalPrice={formattedTraditionalPrice}
        traditionalDiscountMessage={traditionalDiscountMessage}
      />
    </div>
  )
}

export default ProductInfo
